import React from "react";
import moment from "moment";
import UserProfileLink from "components/shared/user-profile-link";

const TableRow = row => {
  const { StartDate, EndDate, CoachName, CoachId, CreatedByName, CreatedById, ChatType, Topic, Status } =
    row;

  return (
    <tr>
      <td>
        {moment(StartDate).format("MM/DD/YYYY")} |{" "}
        {moment(StartDate).format("hh:mm A")} to{" "}
        {moment(EndDate).format("hh:mm A")}
      </td>
      <td>{Topic}</td>
      <td>
        <UserProfileLink userId={CoachId} linkedUserIsS3Staff>
          {CoachName}
        </UserProfileLink>
      </td>
      <td>
        <UserProfileLink userId={CreatedById} linkedUserIsS3Staff>
          {CreatedByName}
        </UserProfileLink>
      </td>
      <td>{Status}</td>
      <td>{ChatType}</td>
    </tr>
  );
};

export default TableRow;
